import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRecordVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={42} height={42} fill='none' {...props}>
    <circle cx={21} cy={21} r={16} fill='#F23645' />
    <circle cx={21} cy={21} r={19.5} stroke='#fff' strokeWidth={3} />
  </svg>
);
export default SvgRecordVideo;
